"use strict";

module.exports = require("./recorder").Recorder;